export function addProtocolToUrl(url, protocol) {
  if(!url){
      return null;
  }
  protocol = protocol || 'https';
  if (!/^((http|https):\/\/)/.test(url)) {
      url = protocol + "://" + url.replace(/^\/\//, '');
  }
  return url;
}